import axios from "axios";
import { Master_Service_TEAMS_URL } from "../Url";
import HashMap from "hashmap";
import { clearLogoutData } from "../logout/action";

var map = new HashMap();
var err;
function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}

export const teamPanDetailsActions = {
  SAVE_TEAMS_PAN_DETAILS_SUCCESS: "SAVE_TEAMS_PAN_DETAILS_SUCCESS",
  SAVE_TEAMS_PAN_DETAILS_ERROR: "SAVE_TEAMS_PAN_DETAILS_ERROR",
};

export function saveTeamsPanDetails(props) {
  const { access_token, values, partnerFirmId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Master_Service_TEAMS_URL}/savePartnerTeamPanDetails`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(saveTeamPanDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(saveTeamPanDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(saveTeamPanDetailsError(err));
          return err.response;
        }
      });
}

export function saveTeamPanDetailsError(error) {
  return {
    type: teamPanDetailsActions.SAVE_TEAMS_PAN_DETAILS_SUCCESS,
    payload: error,
  };
}

export function saveTeamPanDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: teamPanDetailsActions.SAVE_TEAMS_PAN_DETAILS_SUCCESS,
      payload: props,
    });
  };
}
